/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Location_LabelInputs */

const en_image_export_location_label = /** @type {(inputs: Image_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Location:`)
};

const fr_image_export_location_label = /** @type {(inputs: Image_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement d'exportation :`)
};

const de_image_export_location_label = /** @type {(inputs: Image_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportort:`)
};

const it_image_export_location_label = /** @type {(inputs: Image_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione di esportazione:`)
};

const ru_image_export_location_label = /** @type {(inputs: Image_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Место экспорта:`)
};

const es_image_export_location_label = /** @type {(inputs: Image_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación de exportación:`)
};

const zh_cn2_image_export_location_label = /** @type {(inputs: Image_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口地点：`)
};

const ja_image_export_location_label = /** @type {(inputs: Image_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート場所:`)
};

const hi_image_export_location_label = /** @type {(inputs: Image_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात स्थान:`)
};

const pt_pt2_image_export_location_label = /** @type {(inputs: Image_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local de exportação:`)
};

/**
* | output |
* | --- |
* | "Export Location:" |
*
* @param {Image_Export_Location_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_location_label = /** @type {((inputs?: Image_Export_Location_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Location_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_location_label(inputs)
	if (locale === "de") return de_image_export_location_label(inputs)
	if (locale === "it") return it_image_export_location_label(inputs)
	if (locale === "ru") return ru_image_export_location_label(inputs)
	if (locale === "es") return es_image_export_location_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_location_label(inputs)
	if (locale === "ja") return ja_image_export_location_label(inputs)
	if (locale === "hi") return hi_image_export_location_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_location_label(inputs)
	return en_image_export_location_label(inputs)
});